// export class SendMoneyTransactionFlowSession {
//   private static STORAGE_KEY = 'SendMoneyTransactionFlow';

//   private static getStorage(): Storage | null {
//     if (typeof window !== 'undefined') {
//       return window.sessionStorage || window.sessionStorage || null;
//     }
//     return null;
//   }

//   /** Get full JSON object from session */
//   static getAll(): any {
//     try {
//       const storage = this.getStorage();
//       let raw = storage ? storage.getItem(this.STORAGE_KEY) : null;
//       if (!raw && typeof window !== 'undefined' && window.sessionStorage) {
//         raw = window.sessionStorage.getItem(this.STORAGE_KEY);
//       }
//       return raw ? JSON.parse(raw) : {};
//     } catch {
//       return {};
//     }
//   }

//   /** Save/merge a step (instead of overwrite) */
//   static saveStep(step: string, data: any): void {
//     try {
//       const current = this.getAll();
//       current[step] = { ...(current[step] || {}), ...data };
//       const serialized = JSON.stringify(current);
//       const storage = this.getStorage();
//       if (storage) {
//         storage.setItem(this.STORAGE_KEY, serialized);
//       }
//       if (typeof window !== 'undefined' && window.sessionStorage) {
//         window.sessionStorage.setItem(this.STORAGE_KEY, serialized);
//       }
//     } catch (e) {
//       console.warn('Could not save step in transaction session:', e);
//     }
//   }

//   /** Get specific step’s data */
//   static getStep(step: string): any {
//     return this.getAll()[step] || {};
//   }

//   /** Remove all data */
//   static clear(): void {
//     try {
//       const storage = this.getStorage();
//       if (storage) {
//         storage.removeItem(this.STORAGE_KEY);
//       }
//       if (typeof window !== 'undefined' && window.sessionStorage) {
//         window.sessionStorage.removeItem(this.STORAGE_KEY);
//       }
//     } catch {}
//   }

//   /** Get flattened final payload (merge all steps into single object) */
//   static getFinalPayload(): any {
//     const all = this.getAll();
//     return Object.assign({}, ...Object.values(all));
//   }

//   static removeStep(step: string): void {
//     try {
//       const current = this.getAll();
//       if (current[step]) {
//         delete current[step];
//         const serialized = JSON.stringify(current);
//         const storage = this.getStorage();
//         if (storage) {
//           storage.setItem(this.STORAGE_KEY, serialized);
//         }
//         if (typeof window !== 'undefined' && window.sessionStorage) {
//           window.sessionStorage.setItem(this.STORAGE_KEY, serialized);
//         }
//       }
//     } catch {}
//   }
// }
export class SendMoneyTransactionFlowSession {
  private static STORAGE_KEY = 'SendMoneyTransactionFlow';
 
  /** Get full JSON object from session */
  static getAll(): any {
    const raw = sessionStorage.getItem(this.STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  }
 
  /** Save/merge a step (instead of overwrite) */
  static saveStep(step: string, data: any): void {
    const current = this.getAll();
    current[step] = { ...(current[step] || {}), ...data }; // 🔹 merge old + new
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(current));
  }
 
  /** Get specific step’s data */
  static getStep(step: string): any {
    return this.getAll()[step] || {};
  }
 
  /** Remove all data */
  static clear(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
 
  /** Get flattened final payload (merge all steps into single object) */
  static getFinalPayload(): any {
    const all = this.getAll();
    return Object.assign({}, ...Object.values(all));
  }
   static removeStep(step: string): void {
    const current = this.getAll();
    if (current[step]) {
      delete current[step];
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(current));
    }
  }
}